module.exports = __webpack_public_path__ + "media/images/v2/footer_optimized-cdf5d7bf43bb2c24b785d8fd1818ce0e.gif";